module.exports = __webpack_public_path__ + "img/0-01.81e12313.jpg";